import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { KioskService } from "src/app/core/services/kiosk.service";
import { OOOrderType } from "src/app/shared/models/oo-order-type";

@Component({
	selector: "app-kiosk-order-type-select",
	templateUrl: "./kiosk-order-type-select.component.html",
	styleUrls: ["../../../kiosk.styles.scss"],
})
export class KioskOrderTypeSelectComponent implements OnInit {
	@Input() orderTypeSelected: OOOrderType;
	@Output() orderTypeSelectedChange = new EventEmitter<OOOrderType>();

	orderTypes: OOOrderType[];

	constructor(public kioskService: KioskService) {}

	ngOnInit(): void {
		this.orderTypes = this.kioskService.venueService.ooOrderTypes.filter((ot) => ot.kiosk);
	}
}
